export default __webpack_public_path__ + "static/media/1413.7d60a7a5.png";